export const STATUS = {
  NONE: -1,
  ERROR: 0,
  OK: 1,
};
